import { returnLeaveDays } from '.';

export const returnReportedWeekendsHolidays = (
  reportedWeekendsOrHolidays: string[],
) => {
  return returnLeaveDays(reportedWeekendsOrHolidays.sort());
};
